import React from 'react'
import { connect } from 'react-redux'

import {toggleMenu} from '../../store/actions/menuAction'
import {startPtp} from '../../store/actions/playerAction'

import Icon from '../../ui/Icon'

class MenuPlaylists extends React.Component {

  constructor(props){
    super(props)
  }

  playPlaylist(playlist){
    this.props.dispatch(toggleMenu(false))
    this.props.dispatch(startPtp(playlist))
  }

  getPlaylists(){
    return this.props.playlists.map((playlist,index) => {
      return (
        <div 
          className="playlist-wrapper" 
          onClick={() => this.playPlaylist(playlist)} 
          key={index}>
          <div className="playlist-left">
            <div className="playlist-name">
              {playlist.display_name ? playlist.display_name : playlist.name}
            </div>
            <div className="playlist-tracks">
              {playlist.tracks.length} tracks
            </div>
          </div>
          <div className="playlist-right">
            <Icon name="play"/>
          </div>
        </div>
      )
    })
  }

  render(){
    return (
      <div className="menu-playlists-wrapper">
        {this.getPlaylists()}
      </div>
    )
  }

}
function mapStateToProps(store){
  return {
    playlists:store.player.playlists
  }
}

export default connect(mapStateToProps)(MenuPlaylists)


// WEBPACK FOOTER //
// ./src/components/menu/MenuPlaylists.js